import type { CareerCategory } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (
  careerCategories?: CareerCategory[],
  careerPaths?: { id: number; name: string; career_category?: { id: number } }[],
) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'All Career Paths',
    description:
      'Accordion list of all career categories with their career paths. Each category expands to show individual career paths with fit-level color indicators.',
  });

  const categoryToPathMap = (careerCategories ?? []).reduce(
    (acc, category) => {
      const paths = (careerPaths ?? [])
        .filter((p) => p.career_category?.id === category.id)
        .map((p) => p.name);

      if (paths.length > 0) {
        acc[category.short_name] = paths;
      }

      return acc;
    },
    {} as Record<string, string[]>,
  );

  useRegisterAgentContext({
    kind: 'list',
    description:
      'Browseable accordion list of all career paths grouped by career category, with fit-level indicators if the user has a blueprint',
    data: {
      categoryToPathMap: Object.keys(categoryToPathMap).length > 0 ? categoryToPathMap : null,
    },
  });
};
